import {
  QImage_caf_empty_mobile_en3,
  QImage_caf_empty_mobile_ko3,
  QImage_caf_empty_pc_en3,
  QImage_caf_empty_pc_ko3,
} from '@repo/icons/index'
import useIsMobile from '../../../../modules/hooks/common/useIsMobile'
import useTranslation from '../../../../modules/i18n/useTranslation'

const NoCAFPlaceholder = () => {
  const { t, locale, isLocaleKO } = useTranslation()
  const isMobile = useIsMobile()

  const aspect = 375 / 1425

  if (isMobile) {
    return (
      <div className="mb-[100px] flex h-[1425px] w-screen flex-col items-center justify-start pt-[32px]">
        {isLocaleKO ? (
          <QImage_caf_empty_mobile_ko3 width={375} height={1425} />
        ) : (
          <QImage_caf_empty_mobile_en3 width={375} height={1425} />
        )}
      </div>
    )
  } else {
    return (
      <div className="mb-[100px] flex h-[100%] w-[100%] flex-col items-start justify-start pt-[32px]">
        {isLocaleKO ? (
          <QImage_caf_empty_pc_ko3 height={1209} width={688} />
        ) : (
          <QImage_caf_empty_pc_en3 height={1209} width={688} />
        )}
      </div>
    )
  }
}

export default NoCAFPlaceholder

const styles = {
  box: `relative z-[1] `,
  img: `z-[1]`,
  textBox: `absolute top-[140px] z-[2] flex flex-col items-center px-[72px]`,
  lockImg: `mb-[12px] w-[27px]`,
  text: ` text-h5 keep-all text-center font-semibold tracking-tight text-purple-500`,
}
